import { PostsListItemAuthor, AuthorAndMeta } from "lib-core"
export { PostsListItemAuthor, AuthorAndMeta }

export default AuthorAndMeta;
